import { isUndefined } from 'lodash-es'

/**
 * We assume there is only one top domain. This will return strictly horizontal domain with the highest z coordinate.
 * @param domains
 * @returns
 */
const getTopDomain = (domains: Domain[]): Domain | undefined => {
  let topDomain: Domain | undefined

  for (const domain of domains) {
    const isHorizontal = domain.start.z === domain.end.z

    if (isHorizontal) {
      if (isUndefined(topDomain)) {
        topDomain = domain
      } else if (domain.start.z > topDomain.start.z) {
        topDomain = domain
      }
    }
  }

  return topDomain
}

export default getTopDomain
